<template>
    <div class="login-view">
        <div class="big-logo">
            <img class="big-logo-image" src="@/assets/tm-checklist-logo.png" alt="chillServices_logo">
            <h3 class="big-logo-text">Checklist</h3>
        </div>
        <section>
            <infoBox />
        </section>
		<section class="formcontainer">
            <h3 class="login-header">EINLOGGEN</h3>
            <div class="form-container-box">
                <div class="login-fields">
                    <form>
                        <div class="field">
                            <label>{{trans('user_name')}}
                                <input type="email" v-model="email"  id="loginEmail" class="email field-text" placeholder="Email Id" autocomplete="on" />
                            </label>
                        </div>
                        <div class="field">
                            <label>{{trans('password')}}
                                <input type="password" v-model="password"  id="loginPassword" class="password field-text" placeholder="Passwort" autocomplete="on" />
                            </label>
                        </div>
                    </form>
                    <div class="policy" ><a class="field a-tag" href="https://chillservices.com/de/datenschutzerklaerung/" target="_blank" >{{trans('policy')}}</a></div>
                </div>
                <h3 style="color: red" v-if="forgot_password_email_sent">{{trans('reset_email_has_been_sent')}}</h3>
                <h3 style="color: red" v-if="wrong_password">{{trans('wrong_password')}}</h3>
                <div class="button-box">
                    <button v-if="!authLoading" class="button-primary" @click="loginFunc(email, password)">{{trans('login')}}</button>
                    <button v-else-if="authLoading" class="button-primary" ><loadingDots /></button>
                </div>
                <div class="button-box">
                    <button class="button-secondary" @click="forgot_password = !forgot_password">{{trans('forgot_password')}}</button>
                </div>
                <div v-if="forgot_password" class="field">
                    <input type="email" v-model="forgot_email"  id="forgot_email" class="email field-text" placeholder="Email Id" autocomplete="on" />
                </div>
                <div v-if="forgot_password" class="button-box">
                    <button class="button-secondary" @click="forgot()">{{trans('send_reset_email')}}</button>
                </div>
                <div class="button-box">
                    <button class="button-secondary" @click="gotoRegister()">{{trans('register')}}</button>
                </div>
                <div class="button-box">
                    <button class="button-secondary" @click="gotoDelete()">{{trans('Kontolöschung beantragen')}}</button>
                </div>
            </div>
		</section>
        <section class="footer">
            <div class="footer-inner">
                <span class="footer-text fat">CheckList ist ein Produkt der Fa. ChillServices.</span>
                <span class="footer-text">Für weitere Informationen besuchen Sie bitte unsere <a href="https://chillservices.com/">website</a></span>
                <span class="footer-text">© Alle Rechte vorbehalten, 2022.</span>
            </div>
        </section>
    </div>
</template>

<script>
    // import { getAuth, sendPasswordResetEmail } from "firebase/auth";
	export default {
		name: 'login',
		data() {
			return {
                forgot_password: false,
                forgot_email: "",
				email: "",
				password: "",
				accepted: false,
                forgot_password_email_sent: false
			}
		},
		computed: { },
        watch: {
            '$route' () {
                this.authLoading = false
            },
            authLoading: function() {
                console.log('')
            }
        },
		methods: {
            forgot(){
                this.forgot_func(this.forgot_email)
                this.forgot_password_email_sent = true
                this.wrong_password = false
                this.forgot_password = false
            },
			loginFunc(email,pass) {
                this.authLoading = true
				this.login(email,pass)
			},
            gotoRegister(){
                this.$router.push({ path: `/register` });
            },
            gotoDelete(){
                this.$router.push({ path: `/delete` });
            }
		},
		mounted(){

		}
	}
</script>

<style scoped>
    .login-view {
        margin-top: 60px;
    }
    .big-logo {
        display: flex;
        flex-direction: column;
        width: 86vw;
        margin: 0px auto;
        
    }
    .big-logo-image, .big-logo-text {
        margin: 0px auto;
        width: 100px;
        height: auto;
        text-align: center;
    }
    .formcontainer {
        border-left: solid #1B608C 5px;
        width: 90vw;
        max-width: 900px;
        margin: 20px auto 100px auto;
        background-color: #FFF;
        padding: 24px 12px;
        box-sizing: border-box;

    }
    .field {
        display: flex;
        flex-direction: column;
        margin-bottom: 12px;
    }
    /* .form-container-box {  } */
    h3 {
        font-weight: normal;
        font-size: 16px;
        margin-top: 0px;
    }
    .field-text {
        border: none;
        /* border-bottom: solid transparent 2px; */
        border-bottom: solid #565760 1px;
        height: 28px;
    }
    .field-text:focus {
        outline: none;
        border: none;
        border-bottom: solid #51D07D 1px;
    }
    .button-box {
        text-align: center;
    }
    .button-primary {
        width: 100%;
        background-color: #1B608C;
        color: #FFF;
        height: 28px;
        border-radius: 28px;
        border: none;
        margin-top: 8px;
    }
    .button-secondary {
        width: 100%;
        background-color: #ECEDF0;
        color: #000;
        height: 28px;
        border-radius: 28px;
        border: none;
        margin-top: 8px;
    }
    .policy {
        text-align: center;
    }
    .a-tag {
        text-decoration: none;
        color: #1B608C;
        display: inline-block;
    }
    label {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-weight: 400;
    }
    .footer {
        position: fixed;
        left: 0px;
        right: 0px;
        bottom: 0px;
        height: 70px;
        background-color: #F8F8FA;
    }
    .footer-inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 86vw;
        margin: 0px auto;
        /* border-top: solid #CBCCD5 1px; */
    }
    .footer-text {
        display: block;
        font-size: 12px;
    }
    .fat {
        font-size: 14px;
        font-weight: 500;
    }
    /* span {
        font-size: 14px;
        font-weight: 300;
    } */
</style>